// extracted by mini-css-extract-plugin
export var childrenContainer = "_cv-0";
export var virtualScrollArea = "_cv-1";